const fvSwiper = new Swiper('.fv-swiper', {
  loop: true,
  speed: 800,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
    navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
});

new Swiper('.logo-slider', {
  loop: true,
  slidesPerView: 'auto',
  spaceBetween: 10,
  allowTouchMove: false, // スワイプ無効
  speed: 6000,
  autoplay: {
    delay: 0, // 途切れなくループ
  },
  breakpoints: {
    750: {
      spaceBetween: 20,
    }
  }

});

document.querySelectorAll('.collection-products-sliderWrap').forEach((wrapEl) => {
  const sliderEl = wrapEl.querySelector('.collection-products-slider');
  const slideCount = sliderEl.querySelectorAll('.swiper-slide').length;

  const mq = window.matchMedia('(min-width: 750px)');
  const isPC = mq.matches;

  // 発動条件を画面幅で切り替え
  const minSlideCount = isPC ? 5 : 2;

  if (slideCount < minSlideCount) {
    wrapEl.classList.add('is-not-slider');
    return;
  }

  const prevEl = wrapEl.querySelector('.swiper-button-prev');
  const nextEl = wrapEl.querySelector('.swiper-button-next');

  new Swiper(sliderEl, {
    speed: 800,
    loop: false,

    // 画面幅によって切り替え
    slidesPerView: isPC ? 4 : 1.5,
    spaceBetween: isPC ? 20 : 10,
    // centeredSlides: !isPC,

    navigation: {
      prevEl,
      nextEl,
    },
  });
});




document.addEventListener('DOMContentLoaded', () => {
  const mainEl = document.querySelector('.js-article-hero-swiper');
  const thumbEl = document.querySelector('.js-article-hero-thumbs');

  if (!mainEl || !thumbEl) return;

  const thumbsSwiper = new Swiper(thumbEl, {
    slidesPerView: 3,
    spaceBetween: 8,
    watchSlidesProgress: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      750: {
        slidesPerView: 4,
        spaceBetween: 20,
      }
    }
  });

  new Swiper(mainEl, {
    spaceBetween: 0,
    thumbs: {
      swiper: thumbsSwiper,
    },
  });
});

jQuery(function($) {

	if ( $('dl.accordion dt').length > 0 ) {

		$("dl.accordion dt").click(function(){
			$(this).next("dd").slideToggle();
			$(this).toggleClass("open");
		});
	}
});


jQuery(function($) {
    var headerHeight = 0; // ヘッダー追従でない場合 // if not header-following
	// var headerHeight = $('header').innerHeight(); // ヘッダー追従の場合 // if header following
    $('a[href^="#"]').click(function(){
        var href= $(this).attr("href");
        var target = $(href == "#" || href == "" ? 'html' : href);
        if ( target.length > 0 ) {
            var position = target.offset().top - headerHeight - 100;
            $("html, body").animate({scrollTop:position}, 550, "swing");
            return false;
        }
    });
})

// $(function () {
//   if ($(".front-fix-banner").length > 0) {
//     var topBtn = $(".front-fix-banner");
//     var footer = $("footer");

//     $(window).on("scroll resize", function () {
//       var scrollTop = $(this).scrollTop();
//       var winHeight = $(this).height();
//       var footerTop = footer.offset().top;

//       if (scrollTop + winHeight < footerTop) {
//         if (!topBtn.is(":visible")) {
//           topBtn.stop(true, true).fadeIn();
//         }
//       } else {
//         if (topBtn.is(":visible")) {
//           topBtn.stop(true, true).fadeOut();
//         }
//       }
//     });
//   }
// });
$(function() {
    let tabs = $(".js-tab");
    $(".js-tab").on("click", function() {
        $(".active").removeClass("active");
        $(this).addClass("active");
        const index = tabs.index(this);
        $(".js-tab-content").removeClass("show").eq(index).addClass("show");
    });
});

const neonKvSwiper = new Swiper(".p-neon-kv__slider", {
  loop: true,
  speed: 300,
  spaceBetween: 16,
  slidesPerView: 'auto',
  centeredSlides: true,
  autoplay: {
    delay: 3000,
    disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
  },
  breakpoints: {
    750: {
      spaceBetween: 36,
    }
  }
});

const neonSwiper = new Swiper(".p-neon-slider", {
  loop: true,
  speed: 3000,
  spaceBetween: 20,
  slidesPerView: 'auto',
  autoplay: {
    delay: 0
  },
  breakpoints: {
    990: {
      spaceBetween: 49,
    }
  }
});

const neonTxtSwiper = new Swiper(".p-neon-txtSlider", {
  loop: true,
  speed: 10000,
  slidesPerView: 'auto',
  autoplay: {
    delay: 0
  }
});

$(function () {
  $('.menu-drop-sub').hide();

  $('.menu-drop-toggle').on('click', function () {
    const $parent = $(this).closest('.menu-drop-item');
    const $submenu = $parent.find('.menu-drop-sub');

    // 他を閉じたい場合（アコーディオン挙動）
    $('.menu-drop-sub').not($submenu).slideUp(200);
    $('.menu-drop-item').not($parent).removeClass('is-open');

    $submenu.slideToggle(200);
    $submenu.toggleClass('active');
    $parent.toggleClass('is-open');
  });
});
